export default __webpack_public_path__ + "static/image/service_1.75106eb7.png";